@import "~@govbr-ds/core/src/components/tab/tab";

:host {
  width: 100%;
  box-sizing: border-box;
}

:host(:not([is-active])) {
  display: none;
}

:host([is-active]) {
  display: block;
}

:host(.dark-mode) {
  @include dark-mode;

  color: var(--color);
}

:host([disabled]) {
  display: none;
}
